import {RailsApi} from '@/api/rails.api.js'
import {Message} from '@/models/message.model.js'

/**
 * My enrollment messages API service
 */
export class MyEnrollmentMessagesApi extends RailsApi {

  //Props
  basePath = '/enrollments'
  itemKey = 'message'
  itemsKey = 'messages'
  ModelClass = Message

  /**
   * Query
   */
  query(enrollmentId, params, options) {
    return super
      .query(params, options, `/${enrollmentId}/messages`)
  }

  /**
   * Create message
   */
  create(enrollmentId, data) {
    const {itemKey} = this
    return this
      .post(`/${enrollmentId}/messages`, {[itemKey]: data})
  }
}

//Export singleton instance
export const myEnrollmentMessagesApi = new MyEnrollmentMessagesApi()
